@if(mode==='read' && data ){
<div>
    <div nz-row>
        <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12">
            <div nz-row>
                <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2 pt-2">
                    Address Line 1</div>
                <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ data?.street1}}
                </div>
            </div>
        </div>

        <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12">
            <div nz-row>
                <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2 pt-2">
                    Address Line 2</div>
                <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ data?.street2}}
                </div>
            </div>
        </div>
        <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12">
            <div nz-row>
                <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">City
                </div>
                <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ data?.city}}</div>
            </div>
        </div>
    </div>
    <div nz-row>
        <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12">
            <div nz-row>
                <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">State
                </div>
                <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ data?.state ?
                    getValue(data?.state) : data?.state}}</div>
            </div>
        </div>

        <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12">
            <div nz-row>
                <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">Zip
                    Code
                </div>
                <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ data?.zipCode}}
                </div>
            </div>
        </div>

    </div>
    <div nz-row>
        <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12">
            <div nz-row>
                <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">County</div>
                <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{
                    data?.countyOrRegion}}
                </div>
            </div>
        </div>

        <!-- <div nz-col nzSpan="4" class="font-weight-600 pt-2">PSD Code details</div>
        <div nz-col nzSpan="8" class="pt-2">{{ data?.psd_code}}</div> -->
    </div>

    @if(is_permanent){
    <div nz-row style="margin-top:8px">
        <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">Is the Mailing
            address the same as the Physical Address?</div>
        <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{data?.mailing ? "Yes" :
            "No"}}</div>
    </div>
    }
</div>
@if(is_permanent && !data?.mailing){
<nz-divider class="divider"></nz-divider>
}
}
@if(mode==='edit' && addressForm){

<div nzSpan="12" style="margin-top:8px; margin-bottom:12px">
    <nz-row>
        <nz-form-label nzFor="searchAddress" nz-col [nzSm]="8" [nzXs]="24" style="font-weight: 600;">Search Address</nz-form-label>
        <div nz-col [nzSm]="8" [nzXs]="24" class="ppl-form-control search-address">
            <div class="address-field-wrapper">
            <nz-select nzId="searchAddress" nzShowSearch nzServerSearch nzPlaceHolder="Start with the street number (e.g., 123 Main…)"
                [(ngModel)]="selectedValue" [nzShowArrow]="false" [nzFilterOption]="nzFilterOptions"
                (nzOnSearch)="onSearch($event)" (ngModelChange)="validateAddress($event)"
                pplNzAriaLabel nzAriaLabel="Search Physical Address, type address and then select value from dropdown">
                @for(option of listOfOptions; track $index){
                <nz-option [nzValue]="option.value" [nzLabel]="option.text"></nz-option>
                }
            </nz-select>
            <i nz-icon nzType="info-circle" nzTheme="outline"
                nz-tooltip="Please begin typing the address with the street number and provide at least four characters."
                class="info-icon">
            </i>
            </div>
            <div class="manual-toggle pt-2">
                <input type="checkbox" id="manualAddressToggle" #manualToggle (change)="toggleManualAddress(manualToggle.checked)" />
                <label for="manualAddressToggle">Enter address manually</label>
            </div>
        </div>
    </nz-row>
</div>

<div [formGroup]="addressForm" class="lead-details-address">
    <nz-row>
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="street1" class="ppl-form-label">Address Line
                    1*</nz-form-label>
                <nz-form-control class="ppl-form-control">
                    <input nz-input formControlName="street1" id="street1" />
                    <span class="pl-1 error-message">{{validationErrors['street1']}}</span>
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="street2" class="ppl-form-label">Address Line
                    2</nz-form-label>
                <nz-form-control class="ppl-form-control">
                    <input nz-input formControlName="street2" id="street2" />
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item ">
            <nz-row>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="city" class="ppl-form-label">City*</nz-form-label>
                <nz-form-control class="ppl-form-control">
                    <input nz-input formControlName="city" id="city" />
                    <span class="pl-1 error-message">{{validationErrors['city']}}</span>
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item">
            <nz-row>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="state" class="ppl-form-label">State*</nz-form-label>
                <nz-form-control class="ppl-form-control" nzTooltipTitle="Select State">

                    <nz-select formControlName="state" class="ppl-select" nzId="state" nzShowSearch nzAllowClear
                        [ngClass]="{'error': validationErrors['state'] }">
                        @for(opt of states; track $index){
                        <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
                        }
                    </nz-select>
                    <!--  <input nz-input formControlName="state" id="state" /> -->
                    <span class="pl-1 error-message">{{validationErrors['state']}}</span>

                </nz-form-control>
            </nz-row>
        </nz-form-item>
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item ">
            <nz-row>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="zipCode" class="ppl-form-label">Zip Code*</nz-form-label>
                <nz-form-control class="ppl-form-control">
                    <input nz-input formControlName="zipCode" id="zipCode" />
                    <span class="pl-1 error-message">{{validationErrors['zipCode']}}</span>
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item">
            <nz-row>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="countyOrRegion" class="ppl-form-label">County
                    @if(isParticipant){ <span>*</span> }
                </nz-form-label>
                 <nz-form-control class="ppl-form-control">
            <input
                [ngClass]="{'error': (validationErrors['countyOrRegion']) }"
                [attr.aria-invalid]="(validationErrors['countyOrRegion']) ? 'true' : 'false'"
                [attr.aria-describedby]="(validationErrors['countyOrRegion']) ? 'countyOrRegion-error' : null"
                nz-input formControlName="countyOrRegion" id="countyOrRegion" aria-label="County or Region" />
            @if (validationErrors['countyOrRegion']) {
            <span id="countyOrRegion-error" class="pl-1 error-message"
                role="alert">{{validationErrors['countyOrRegion']
                }}</span>
            }
        </nz-form-control>
            </nz-row>
        </nz-form-item>
        <!-- <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item ">
            <nz-row>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="psd_code" class="ppl-form-label">PSD Code
                    Details</nz-form-label>
                <nz-form-control class="ppl-form-control">
                    <input nz-input formControlName="psd_code" id="psd_code" />
                    <span class="pl-1 error-message">{{validationErrors['psd_code']}}</span>
                </nz-form-control>
            </nz-row>
        </nz-form-item> -->
    </nz-row>
    @if(is_permanent){
    <nz-row>
        <nz-col nzSpan="12" [nzXs]="24">
            <nz-form-item class="ppl-form-item">
                <nz-form-label [nzXs]="24" [nzSm]="21" [nzLg]="10" [nzXl]="9" [nzXXl]="4" nzFor="mailing"
                    class="ppl-form-label">Is the Mailing address the same
                    as the Physical Address?</nz-form-label>
                <nz-form-control class="ppl-form-control">
                    <nz-switch class="ppl-switch" nzId="mailing" formControlName="mailing" pplNzAriaLabel
                        nzAriaLabel="mailing"></nz-switch>
                </nz-form-control>
            </nz-form-item>
        </nz-col>
    </nz-row>

    }
</div>

}